export default function isDateAfterBugCaptureRelease(date) {
	return date > new Date('2024-08-27 12:30 UTC')
}
